import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { USER_OVERVIEW_LIMIT, listUsersOverview } from '@/lib/messages.ts';
import type { UserOverview } from '@/types/messages.ts';
import type { PaginatedResponse } from '@/types/pagination.ts';

export interface PeopleOverview {
  users: UseQueryResult<PaginatedResponse<UserOverview>>;
  /** The person whose transcript is open, once the list has them. */
  selectedUser: UserOverview | null;
}

/** Everyone who talked to Wundo, within the organisation picked in the header. */
export function usePeopleOverview(
  organisationId: string | undefined,
  userId: string | null,
): PeopleOverview {
  const users = useQuery({
    queryKey: ['messagesUsers', organisationId ?? null],
    queryFn: () => listUsersOverview(1, USER_OVERVIEW_LIMIT, organisationId),
  });
  const selectedUser = (users.data?.data ?? []).find((one) => one.id === userId) ?? null;

  return { users, selectedUser };
}
